<template>
  <div ui-view>
    <div class="row">
      <div :class="`col-lg-${lgColSize} col-md-6 col-xs-12 workflow-block`" v-for="(workflowGroup, workflowGroupId) in workflowGroups">
        <card
          :title="$t(workflowGroup.title)"
          body-class="no-padding"
          :show="true"
          :collapsable="false"
          image-height="80"
          v-on:clickheader="workflowGroup.show = !workflowGroup.show"
        >
          <img width="50%" :src="$parent.getImgUrl(workflowGroup.image)" class="pad-10" style="margin: 0 auto; display: block" />
          <div class="pad-10" v-html="$t(workflowGroup.description)"></div>
          <div class="pad-10 bg-grey-lightest a-c">
            <button type="button" class="btn btn-lg btn-success" v-on:click="openDialog(workflowGroupId)"><i class="fas fa-plus"></i> {{ $t('Projects.add') }}</button>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
var view = require('../view.js'),
    viewData = {
      show: false
    },
    resetData = Object.assign({}, viewData);

export default view(viewData, {
  props: {

  },
  computed: {
    workflowGroups() {
      return typeof this.$root.workflowGroups === 'object' ? this.$root.workflowGroups : {};
    },
    numberOfWorkflowGroups() {
      return Object.keys(this.workflowGroups).length;
    },
    lgColSize() {
      const x = Math.ceil(12 / this.numberOfWorkflowGroups);
      return Math.min(Math.max(2, x), 4);
    }
  },
  mounted() {
    this.$parent.viewTitle = this.$t('Packages.title');
    this.reset();
  },
  methods: {
    reset() {
      Object.keys(this.workflowGroups).forEach((k) => {
        this.workflowGroups[k].show = false;
      });
    },
    openDialog(workflowGroupId) {
      this.$parent.$refs.newProject.openDialog(workflowGroupId);
    },
    toggle(workflowGroupId) {
      this.toggleStatus[workflowGroupId] = typeof this.toggleStatus[workflowGroupId] === 'undefined' ? true : !this.toggleStatus[workflowGroupId];
    }
  }
});
</script>

<style type="text/css">
.workflow-block .card-title {
  width: calc(100% - 50px);
}
.workflow-block .card-title > span {
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
